const buildVerifyEmailBody = email => {
  return {
    data: {
      attributes: {
        email
      }
    }
  };
};

export default {
  buildVerifyEmailBody
};



// WEBPACK FOOTER //
// ./src/api/helpers/accounts.js